import { styled, Typography } from '@mui/material';
import { LegendType } from '../Chart.types';
import { LegendTypeDataSelector } from '../ChartWrapper';

export const ITEM_HEIGHT = 18;
export const ROW_GAP = 2;
export const MAX_ROWS = 2;
export const LIST_MAX_HEIGHT = ITEM_HEIGHT * MAX_ROWS + ROW_GAP * (MAX_ROWS - 1);

export const highlighted = () =>
  ({
    '&[data-interactive]': {
      cursor: 'pointer',
    },
    '&[data-highlighted]': {
      backgroundColor: 'var(--color-surface-base-secondary)',
    },
    '&[data-selected]': {
      backgroundColor: 'var(--color-surface-base-tertiary)',
    },
    '&[data-selected][data-highlighted]': {
      backgroundColor: 'var(--color-surface-base-secondary)',
    },
  }) as const;

export const ColorDot = ({ color }: { color: string }) => (
  <svg width={10} height={10} style={{ width: 10, height: 10, flexShrink: 0 }} aria-hidden>
    <circle cx={5} cy={5} r={5} fill={color} />
  </svg>
);

export const StyledLegendLabel = styled(Typography)(() => ({
  color: 'var(--color-content-base-secondary)',

  svg: {
    marginRight: 6,
    verticalAlign: 'middle',
  },

  [`${LegendTypeDataSelector[LegendType.tableRight]} &`]: { svg: { marginRight: 16 } },

  [`${LegendTypeDataSelector[LegendType.tableRight]} &:not(:first-child)`]: { color: 'var(--color-content-base-primary)' },

  [`${LegendTypeDataSelector[LegendType.tableRight]} &:nth-of-type(2)`]: { fontWeight: 600 },
}));
